module.exports = __webpack_public_path__ + "img/3.270fe461.jpg";